import pxToRem from "theme/base/pxToRem";
import {
  BaseDisplayProperties,
  BaseHeadingProperties,
  BaseProperties,
  TypographyRoot,
} from "theme/types/base/typography";

const baseProperties: BaseProperties = {
  fontFamily: '"Averta Std CY", sans-serif',
  fw_thin_100: 100,
  fw_light_300: 300,
  fw_regular_400: 400,
  fw_semibold_500: 500,
  fw_semibold_600: 500,
  fw_bold_700: 700,
  fw_extrabold_800: 800,
  fw_black_900: 900,
  XXS_11: pxToRem(11),
  XS_12: pxToRem(12),
  XX_13: pxToRem(13),
  SM_14: pxToRem(14),
  MD_16: pxToRem(16),
  LG_18: pxToRem(18),
  XL_20: pxToRem(20),
  XXL_24: pxToRem(24),
  XXXL_30: pxToRem(30),
  XXXXL_54: pxToRem(54),
};

const baseHeadingProperties: BaseHeadingProperties = {
  fontFamily: baseProperties.fontFamily,
  fontWeight: baseProperties.fw_bold_700,
};

const baseDisplayProperties: BaseDisplayProperties = {
  fontFamily: baseProperties.fontFamily,
  fontWeight: baseProperties.fw_light_300,
  lineHeight: 1.2,
};

const typography: TypographyRoot = {
  fontFamily: baseProperties.fontFamily,
  fw_thin_100: baseProperties.fw_thin_100,
  fw_light_300: baseProperties.fw_light_300,
  fw_regular_400: baseProperties.fw_regular_400,
  fw_semibold_500: baseProperties.fw_semibold_500,
  fw_semibold_600: baseProperties.fw_semibold_600,
  fw_bold_700: baseProperties.fw_bold_700,
  fw_extrabold_800: baseProperties.fw_extrabold_800,
  fw_black_900: baseProperties.fw_black_900,
  h1: {
    fontSize: pxToRem(48),
    lineHeight: 1.25,
    ...baseHeadingProperties,
  },
  h2: {
    fontSize: pxToRem(36),
    lineHeight: 1.3,
    ...baseHeadingProperties,
  },
  h3: {
    fontSize: pxToRem(30),
    lineHeight: 1.375,
    ...baseHeadingProperties,
  },
  h4: {
    fontSize: pxToRem(24),
    lineHeight: 1.375,
    ...baseHeadingProperties,
  },
  h5: {
    fontSize: pxToRem(20),
    lineHeight: 1.375,
    ...baseHeadingProperties,
  },
  h6: {
    fontSize: pxToRem(16),
    lineHeight: 1.625,
    ...baseHeadingProperties,
  },
  subtitle1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.XL_20,
    fontWeight: baseProperties.fw_light_300,
    lineHeight: 1.625,
  },
  subtitle2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.MD_16,
    fontWeight: baseProperties.fw_light_300,
    lineHeight: 1.6,
  },
  body1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.MD_16,
    fontWeight: baseProperties.fw_regular_400,
    lineHeight: 1.6,
  },
  button: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.SM_14,
    fontWeight: baseProperties.fw_light_300,
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.XS_12,
    fontWeight: baseProperties.fw_light_300,
    lineHeight: 1.25,
  },
  overline: {
    fontFamily: baseProperties.fontFamily,
  },
  d1: {
    fontSize: pxToRem(80),
    ...baseDisplayProperties,
  },
  d2: {
    fontSize: pxToRem(72),
    ...baseDisplayProperties,
  },
  d3: {
    fontSize: pxToRem(64),
    ...baseDisplayProperties,
  },
  d4: {
    fontSize: pxToRem(56),
    ...baseDisplayProperties,
  },
  d5: {
    fontSize: pxToRem(48),
    ...baseDisplayProperties,
  },
  d6: {
    fontSize: pxToRem(40),
    ...baseDisplayProperties,
  },
  size: {
    xxs_11: baseProperties.XXS_11,
    xs_12: baseProperties.XS_12,
    xx_13: baseProperties.XX_13,
    sm_14: baseProperties.SM_14,
    md_16: baseProperties.MD_16,
    lg_18: baseProperties.LG_18,
    xl_20: baseProperties.XL_20,
    xxl_24: baseProperties.XXL_24,
    xxl_30: baseProperties.XXXL_30,
    xxl_54: baseProperties.XXXXL_54,
  },
  lineHeight: {
    sm: 1.25,
    md: 1.5,
    lg: 2,
  },
};

export default typography;
